// @ts-nocheck
import { useEffect, useRef } from "react";

export const useClickOutside = (elRef: any, callback: any) => {
  const callbackRef = useRef(null);
  callbackRef.current = callback;
  useEffect(() => {
    const handleOutsideClick = (e: any) => {
      if (e.target.id === "portal") {
        return;
      }
      if (elRef.current && !elRef.current.contains(e.target)) {
        callbackRef.current(e);
      }
    }
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    }
  }, [elRef, callback]);

}